import { getModule } from "../../../appmodules";
import { IOmniaSession } from "../../types";
import { isFunction } from "../../utils/utils";
import { NutritionVersionService } from "./service";


export const v2Module = getModule(undefined, "nutrition2", {
    external: true,
    path: "/nutrition/v2/:action?/:id?",
    checkModule: (ns: any) => isFunction(ns["start"])
})

class controller {

    static $inject = [
        "$scope",
        "$q",
        "OmniaSession",
        "OmniaNutritionVersion"
    ]

    constructor(
        private readonly $scope: ng.IScope,
        private readonly $q: ng.IQService,
        private readonly session: IOmniaSession,
        private readonly version: NutritionVersionService
    ) {

        $scope.$watch(
            () => this.version.getCurrentVersion(),
            version => {


                if (version === undefined) {
                    return
                }

                if (version === 1) {
                    this.$scope["version"] = version
                    return
                }

                v2Module.loader(this.$q).then(omniaModule => {

                    this.$scope["version"] = version
                    this.$scope["$resolve"] = { omniaModule }

                })


            })

    }
}


export const versionSelector = {
    controller,
    template: `
        <omnia-nutri ng-if="version === 1"></omnia-nutri>
        <omnia-external-module ng-if="version === 2"></omnia-external-module>
    `,
}